export const defaultCenter = { lat: 33.6650395, lng: -117.7509238 }; // COX headquarter address
const SDK_URL = 'https://maps.googleapis.com/maps/api/js?client=gme-coxenterprises&callback=initMap&libraris=marker';

export async function injectGoogleMapSDK(): Promise<any> {
  if (window['googlemapsLoaded']) {
    return;
  }
  return new Promise((resolve) => {
    window['initMap'] = function () {
      window['googlemapsLoaded'] = true;
      resolve(true);
    };
    const script = document.createElement('script');
    script.id = 'googleMaps';
    script.src = SDK_URL;
    document.body.appendChild(script);
  });
}

export const markerStyle = {
  path: 'M15.6897 33.314C6.04098 19.3263 4.25 17.8907 4.25 12.75C4.25 5.70835 9.95835 0 17 0C24.0417 0 29.75 5.70835 29.75 12.75C29.75 17.8907 27.959 19.3263 18.3103 33.314C17.6771 34.2287 16.3228 34.2286 15.6897 33.314Z',
  fillColor: '#225eaa',
  fillOpacity: 1,
  scale: 1,
  strokeColor: '#225eaa',
  color: '#fff',
  transform: 'translateX(-5px), translateY(-5px)',
  anchor: {
    x: 17,
    y: 32,
  },
  labelOrigin: { x: 15.5, y: 15 },
};

export const markerStyleSecondary = {
  ...markerStyle,
  fillColor: '#fff',
  strokeColor: '#225eaa',
  color: '#225eaa',
};
